import React from 'react';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import { Text, Group, Image } from 'react-konva';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import CheckIcon from './icons/check-icon.svg';
import CloseIcon from './icons/close-icon.svg';
import QuestionIcon from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-option-label/icons/question-icon.svg';
import { useTranslation } from 'i18n';
import { ucFirst } from 'utils/js';
import { color, typography } from 'styles/settings';
import { ANSWER_TYPE } from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-option-label';

const checkIcon = new window.Image();
checkIcon.src = CheckIcon;

const closeIcon = new window.Image();
closeIcon.src = CloseIcon;

const questionIcon = new window.Image();
questionIcon.src = QuestionIcon;

interface QuestionnaireNodeProps extends NodeProps {}

const horizontalPadding = 12;
const verticalPadding = 10;

function QuestionnaireNode(props: QuestionnaireNodeProps) {
  const { node } = props;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();

  const { width, height } = getNodeDimensionsByType(node?.type);

  const containerWidth = width - horizontalPadding * 2;
  const containerHeight = height - verticalPadding * 2;

  // @ts-ignore
  const text = node?.question;
  // @ts-ignore
  const answerType = node.answerType;
  const isTextAnswer =
    answerType != 'yes' && answerType != 'no' && answerType != 'maybe';
  return (
    <>
      <Node {...props} width={width} height={height}>
        {({ Rect }) => {
          return (
            <>
              <GlobalLinksIndicator node={node} x={width} />
              {Rect}
              {/* <NodeHeader
                x={0}
                offsetY={45}
                fill="#1C1B18"
                fontStyle="bold"
                text={node.name ?? ''}
                width={width - 30}
                isReference={node.isReference}
              /> */}
              <Group
                x={horizontalPadding}
                y={verticalPadding}
                width={containerWidth}
                height={containerHeight}>
                <Text
                  text={text}
                  width={containerWidth - 20}
                  height={containerHeight}
                  fontFamily={typography.font.fontFamily}
                  fontStyle="bold"
                  fontSize={16}
                  lineHeight={1.5}
                  wrap="word"
                />

                {!isTextAnswer && (
                  <AnswerType
                    width={containerWidth}
                    height={containerHeight}
                    type={answerType}
                  />
                )}
                {isTextAnswer && (
                  <Text
                    y={80}
                    text={answerType}
                    width={containerWidth - 20}
                    height={containerHeight - 80}
                    fontFamily={typography.font.fontFamily}
                    // fontStyle="bold"
                    fontSize={16}
                    lineHeight={1.5}
                    wrap="char"
                  />
                )}
              </Group>

              <NodeContextMenu width={width} height={height} node={node} />
            </>
          );
        }}
      </Node>
    </>
  );
}

function AnswerType({ type, width, height }) {
  const { t } = useTranslation();

  function getColor() {
    switch (type) {
      case ANSWER_TYPE.YES:
        return color.brand.green;
      case ANSWER_TYPE.NO:
        return color.ui.danger;
      case ANSWER_TYPE.OPEN:
        return color.neutral.plainBlack;
    }
  }

  function getIcon() {
    switch (type) {
      case ANSWER_TYPE.YES:
        return checkIcon;
      case ANSWER_TYPE.NO:
        return closeIcon;
      case ANSWER_TYPE.OPEN:
        return questionIcon;
    }
  }

  function getOffsetX() {
    switch (type) {
      case ANSWER_TYPE.YES:
        return 50;
      case ANSWER_TYPE.NO:
        return 50;
      case ANSWER_TYPE.OPEN:
        return 65;
      default:
        return 0;
    }
  }

  return (
    <Group x={width - getOffsetX()} y={height / 3 + 10}>
      <Image image={getIcon()} width={18} height={18} />
      <Text
        x={22}
        offsetY={2}
        fill={getColor()}
        text={ucFirst(t(type))}
        fontFamily={typography.font.fontFamily}
        fontStyle="bold"
        width={50}
        height={24}
        fontSize={16}
        lineHeight={1.5}
      />
    </Group>
  );
}

export default QuestionnaireNode;
